// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Romania from '../_raw/flag/icon_flag_romania.png';

export default () => <img src={Romania} alt="Romania" />;
